import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  InputBase,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Menu as MenuIcon, Search as SearchIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface GuestHeaderProps {
  toggleDrawer: () => void;
}

const GuestHeader: React.FC<GuestHeaderProps> = ({ toggleDrawer }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: "#fff",
        borderBottom: "1px solid #E5E7EB",
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          px: { xs: 1.5, sm: 2.5, md: 4 },
          minHeight: 72,
          gap: 1.5,
        }}
      >
        {/* Left Section */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={toggleDrawer}>
            <MenuIcon sx={{ color: "#111827" }} />
          </IconButton>
          {!isMobile && (
            <Typography
              variant="h6"
              sx={{
                color: "#111827",
                fontWeight: 800,
                fontSize: 20,
                fontFamily: '"Lexend", sans-serif',
                cursor: "pointer",
              }}
              onClick={() => navigate("/")}
            >
              StageLink
            </Typography>
          )}
        </Box>

        {/* Search Bar (hide on mobile) */}
        {!isMobile && (
          <Box
            sx={{
              position: "relative",
              flex: 1,
              maxWidth: 420,
              mx: { xs: 1, md: 4 },
              backgroundColor: "#F9FAFB",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              px: 2,
              height: 44,
              border: "1px solid #E5E7EB",
            }}
          >
            <SearchIcon sx={{ color: "#9CA3AF", mr: 1 }} />
            <InputBase
              placeholder="Search talents, services..."
              sx={{
                flex: 1,
                fontFamily: '"Lexend", sans-serif',
                fontSize: 14,
                color: "#111827",
              }}
            />
          </Box>
        )}

        {/* Right Section - Auth Buttons */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Login Button */}
          {!isMobile && (
            <Button
              onClick={() => navigate("/sign-in")}
              sx={{
                fontWeight: 600,
                color: "#6366F1",
                textTransform: "none",
                fontFamily: '"Lexend", sans-serif',
                fontSize: 14,
                px: 2,
                "&:hover": {
                  backgroundColor: "#f0f4ff",
                },
              }}
            >
              Login
            </Button>
          )}

          {/* Sign Up Button */}
          {!isMobile && (
            <Button
              onClick={() => navigate("/register")}
              variant="contained"
              sx={{
                background: "linear-gradient(135deg, #9F03FF 0%, #6366F1 100%)",
                color: "#fff",
                fontWeight: 600,
                textTransform: "none",
                fontFamily: '"Lexend", sans-serif',
                fontSize: 14,
                px: 3,
                py: 1,
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(159, 3, 255, 0.3)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #7c00cc 0%, #5855EB 100%)",
                  transform: "translateY(-1px)",
                },
                transition: "all 0.3s ease",
              }}
            >
              Sign Up
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default GuestHeader;
